import getRoutes from './routes'

// initialise global parameters
export default function initRoutes(options) {
  const { Vue, store } = options

  var _routes = getRoutes({ store: store })

  Vue.$coreRoutes = _routes || []
}
